// extracted by mini-css-extract-plugin
export var reverse = "Row-module--reverse--830fb";
export var row = "Row-module--row--36828";